import React, { useEffect, useState } from 'react';
import './Project_Section.css';
import { FaGithub, FaExternalLinkAlt, FaCode } from 'react-icons/fa';

export function ProjectSection({ isVisible }) {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/projects`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();

        const sortedProjects = (data.projects || []).sort((a, b) =>
          new Date(b.end_date) - new Date(a.end_date)
        );

        setProjects(sortedProjects);
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    };

    fetchProjects();
  }, []);

  if (!isVisible || projects.length === 0) return null;

  return (
    <div className="project-section">
      <h1 className="section-title">
        <FaCode style={{ color: '#44a08d' }} size={35} />
        Featured Projects
      </h1>
      <div className="projects-grid">
        {projects.map((project) => (
          <div key={project.project_id} className="project-card">
            <div className="project-image">
              <img src={project.thumbnail} alt={project.name} loading="lazy" />
            </div>
            <div className="project-card-content">
              <h2 className="project-title">{project.name}</h2>
              <p className="project-duration">
                {project.start_date} - {project.end_date}
              </p>
              <p className="project-description">{project.description}</p>
              {project.skills_used && (
                <div className="tech-stack">
                  {project.skills_used.map((tech, idx) => (
                    <span key={idx} className="tech-tag">{tech}</span>
                  ))}
                </div>
              )}
              {project.highlights && (
                <ul className="project-points">
                  {project.highlights.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              )}
              <div className="project-links">
                {project.github_link && (
                  <a href={project.github_link} target="_blank" rel="noopener noreferrer" title="View Code">
                    <FaGithub />
                  </a>
                )}
                {project.live_link && (
                  <a href={project.live_link} target="_blank" rel="noopener noreferrer" title="Live Demo">
                    <FaExternalLinkAlt />
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProjectSection;
